import { AssumeRoleCommand, Credentials } from '@aws-sdk/client-sts'
import { SECRETS_CONFIG } from '../config/SecretsConfig'
import { RoleSessions } from '../constants/RoleSessions'
import { ErrorUtils }  from '../utilities/ErrorUtils'
import { CLIENT_FACTORY } from './ClientFactory'
import { APP_CONFIG } from '../config/AppConfig'

export class CredentialFactory {
  private static instance: CredentialFactory

  static getInstance() {
    if (!this.instance) {
      this.instance = new this()
    }

    return this.instance
  }

  async assumeRole(): Promise<Credentials> {
    const roleArn = APP_CONFIG.getSesRoleArn()
    const command = new AssumeRoleCommand({
      ExternalId: SECRETS_CONFIG.getSesRoleExternalId(),
      RoleSessionName: RoleSessions.GCL_SES_ROLE,
      RoleArn: roleArn,
    })

    try {
      const client = CLIENT_FACTORY.getSTSClient()
      const response = await client.send(command)
      return response.Credentials!
    } catch (e) {
      throw new Error(`Unable to assume role for ${roleArn}: ` + ErrorUtils.getMessage(e))
    }
  }
}

export default CredentialFactory

export const CREDENTIAL_FACTORY = CredentialFactory.getInstance()
